import { render, staticRenderFns } from "./forms.vue?vue&type=template&id=4e5f99b3&scoped=true"
import script from "./forms.vue?vue&type=script&lang=ts"
export * from "./forms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f99b3",
  null
  
)

export default component.exports